import { FC, lazy, Suspense } from "react";
import { useIsMobile } from "@/common/hooks/useIsMobile";
import MobileHeader from "@/widgets/Header/mobile";

const DesktopHeader = lazy(
  () => import(/* webpackChunkName: "desktop-header" */ "./desktop"),
);

interface Props {
  showButton?: boolean;
}

export const Header: FC<Props> = ({ showButton = true }) => {
  const isMobile = useIsMobile();
  return (
    <>
      {isMobile && <MobileHeader />}
      {!isMobile && (
        <Suspense fallback={null}>
          <DesktopHeader showButton={showButton} />
        </Suspense>
      )}
    </>
  );
};
